export const mainLinearGradient = 'linear-gradient(115.11deg, #3DA9F8 7.09%, #35C6C9 65.83%, #A6E177 99.06%)';

export const dashboardLeftLinearGradient = 'linear-gradient(118.51deg, #3DA9F8 33.08%, #35C6C9 90.31%)';

export const dashboardRightLinearGradient = 'linear-gradient(115.13deg, #35C6C9 26.96%, #A6E177 95%)';

export const circularProgressGradient = 'linear-gradient(132.73deg, #3DA9F8 -0.64%, #35C6C9 50.15%, #A6E177 99.88%)';

export const MainLinearGradientSVG = () => (
  <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="MainLinearGradientSVG" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="7.09%" style={{stopColor: '#3DA9F8'}} />
        <stop
          offset="65.83%"
          style={{
            stopColor: '#35C6C9',
          }}
        />
        <stop offset="99.06%" style={{stopColor: '#A6E177'}} />
      </linearGradient>
    </defs>
    <rect width="100%" height="100%" fill="url(#myGradient)" />
  </svg>
);
